import {Component, OnInit} from '@angular/core';
import {Globals} from './globals';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'Laureate Application Portal';

  constructor(public globals: Globals, public cookieService: CookieService) {
    this.globals.isUserLoggedIn = cookieService.get('UVMAppLoggedInToken') !== '';
    this.globals.isCreateApplication = false;
    this.globals.allApplications = false;
  }

  ngOnInit() {
  }
}
